import styled from "styled-components";

export const CardsTemplatesContainer = styled.div`
  column-count: 2;
  column-gap: 20px;
  row-gap: 20px;

  & > div {
    break-inside: avoid;

    &:not(:last-child) {
      margin-bottom: 20px;
    }
  }
`;

export const OverviewCardsTemplatesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
  column-gap: 16px;
`;
